'use es6';

import map from 'bender-url!../../../img/map.svg';
import mobileOnboardingPoweringUp from 'bender-url!../../../img/mobile-onboarding-powering-up.svg';
import designManager from 'bender-url!../../../img/design-manager.svg';
import global from 'bender-url!../../../img/global.svg';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const getImageSrc = name => {
  switch (name) {
    case 'map':
      return map;
    case 'mobileOnboardingPoweringUp':
      return mobileOnboardingPoweringUp;
    case 'designManager':
      return designManager;
    case 'global':
      return global;
    default:
      return map;
  }
};
const StyledImage = styled.img.withConfig({
  displayName: "ResultHeaderIllustration__StyledImage"
})(["font-weight:400;font-size:14px;color:#33475b;line-height:24px;font-family:", ";text-align:center;width:150px;box-sizing:border-box;border:0;vertical-align:middle;max-width:100%;object-fit:contain;"], props => props.theme.$webFontFamily);
const ResultHeaderIllustration = props => {
  return /*#__PURE__*/_jsx("div", {
    className: "result-header-illustration",
    children: /*#__PURE__*/_jsx(StyledImage, {
      src: getImageSrc(props.name),
      alt: props.alt
    })
  });
};
export default ResultHeaderIllustration;